export type PropertyKindOption = "residential" | "commercial";

export interface RadarPrefill {
  cityFromUrl: string;
  neighborhoodFromUrl: string;
  /** Valor inicial do campo bairro/região */
  neighborhoodInput: string;
  maxRent: string;
  minRooms: string;
  propertyKind: PropertyKindOption;
  /** id do filtro de imóvel na URL (imovelType), se houver */
  propertyTypeId: string;
}

export function getRadarPrefill(search: string): RadarPrefill {
  const q = search.startsWith("?") ? search.slice(1) : search;
  const p = new URLSearchParams(q);
  const neighborhoodFromUrl = p.get("neighborhood")?.trim() || "";
  const cityFromUrl = p.get("city")?.trim() || "";
  const neighborhoodInput =
    neighborhoodFromUrl || cityFromUrl || "";

  const rawValues = p.get("values");
  let maxRent = "";
  if (rawValues) {
    const parts = rawValues
      .split(",")
      .map((s) => Number(s.trim()))
      .filter((n) => !Number.isNaN(n));
    if (parts.length >= 2) maxRent = String(parts[1]);
    else if (parts.length === 1) maxRent = String(parts[0]);
  }

  const roomsRaw = p.get("rooms");
  const minRooms = roomsRaw && roomsRaw !== "0" ? roomsRaw : "";

  const imovelType = p.get("imovelType");
  const propertyTypeId =
    imovelType && !Number.isNaN(Number(imovelType)) ? imovelType : "";

  return {
    cityFromUrl,
    neighborhoodFromUrl,
    neighborhoodInput,
    maxRent,
    minRooms,
    propertyKind: "residential",
    propertyTypeId,
  };
}
